module.exports = __webpack_public_path__ + "img/q.60e56769.jpg";